import React,{useContext} from 'react'
import getValue from './getValue'
import ItemNumber from './item-number'
import ItemText from './item-text'
import ContextManager from "./context-manager";

export default function SkuLayout({productSampleSku, I18n}) {
    const {postData} = useContext(ContextManager);
    const productFobPriceUnit = getValue("productFobPriceUnit")
    const productFobPriceUnitEven = getValue("productFobPriceUnitEven")
    // const productSkuInfo = getValue("productSkuInfo")

    // 货币
    const currencyPattern = '$ {0}';
    const prices = productSampleSku.map(i => i.price).sort()
    let uniqueItems = [...new Set(prices)]
    
    const renderSku = (item, index) => {
        // 用于数组过滤展示
        // 最后展示数字
        if (index === postData.skuInfo.length - 1) {
            return <ItemNumber data={item} key={item.id}/>
        }else{
            return <ItemText data={item} key={item.id}/>
        }
    }

    return (
        <div className="sku-layout">
                <div className="sku-header">
                    {uniqueItems.length === 1 ? <strong>{currencyPattern.replace('{0}', uniqueItems[0])}</strong> :
                    <strong>{currencyPattern.replace('{0}', prices[0] + '-' + prices.pop())}</strong>}
                    <span className="lower">/{productFobPriceUnit}</span>
                    <span>|</span>
                    <span className="hight">1 {productFobPriceUnit}/{productFobPriceUnitEven}</span>
                    <span>{I18n.get('minOrder')}</span>
                </div>
                <div className="sku-body">
                    {postData.skuInfo.map((item, index) => renderSku(item, index))}
                </div>
            </div>
    )
}
